
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Roubaix dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Roubaix certifiée Google Partner, accompagne les entreprises roubaisiennes pour booster leur visibilité en ligne et élargir leur clientèle.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Roubaix dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Roubaix certifiée Google Partner, accompagne les entreprises roubaisiennes pour booster leur visibilité en ligne et élargir leur clientèle.",
        },
      ],
    };
  },
};
